import { Button } from '@music-vine/cadence/ui';

/**
 * Shown in place of {@link ./scene-skeleton} when a code-split scene's chunk
 * fails or takes too long to load (DEV-7273), most often a tab that has
 * outlived a deploy. A full reload picks up the current build's assets.
 */
const SceneLoadError = () => <div className="flex flex-col gap-6 p-7 md:p-10" role="alert" data-sentry-component="SceneLoadError" data-sentry-source-file="scene-load-error.tsx">
    <div className="flex flex-col gap-2">
      <h2 className="font-aeonik font-bold text-2xl text-gray-950 dark:text-white">
        Something went wrong
      </h2>
      <p className="text-pretty text-base text-gray-700 dark:text-gray-200">
        This didn't load properly. Refresh the page and try again.
      </p>
    </div>

    <div className="flex sm:justify-end">
      <Button className="w-full sm:w-auto" onClick={() => window.location.reload()} size="lg" type="button" variant="brand" data-sentry-element="Button" data-sentry-source-file="scene-load-error.tsx">
        Refresh page
      </Button>
    </div>
  </div>;
export default SceneLoadError;